/**
 * Beschriftungen einer Wohneinheit (HM-079) — außerhalb der Ansichten, weil der
 * Rahmen sie für die Kopfleiste braucht und von Wohneinheiten nichts wissen
 * soll (dieselbe Regel wie `meterHeadline`).
 */
import type { ApiComponents } from "@hausmeter/sdk";

type SiteArea = ApiComponents["schemas"]["SiteArea"];

export function meteringPointCountLabel(count: number): string {
  if (count === 0) return "keine Messstelle";
  return count === 1 ? "1 Messstelle" : `${count} Messstellen`;
}

/** Name und Faktenzeile für die Kopfleiste: Lage · Messstellen · selbstgenutzt. */
export function unitHeadline(area: SiteArea): { title: string; subtitle: string } {
  const parts = [
    ...(area.location === null ? [] : [area.location]),
    meteringPointCountLabel(area.meteringPointCount),
    ...(area.selfOccupied ? ["selbstgenutzt"] : []),
  ];
  return { title: area.name, subtitle: parts.join(" · ") };
}
